import React, { FC, memo, useMemo } from 'react'
import { useRouter } from 'next/router'
import { ListIcon, Text, Flex } from '@chakra-ui/react'

import { Trigger } from 'components'
import { SidebarSubItemsForViews, SiderbarWithViewCommonProps } from '../..'

type Props = SidebarSubItemsForViews & SiderbarWithViewCommonProps

const SidebarWithViewsItem: FC<Props> = ({ view, setView, Icon, name, subItems, pageKey }) => {
  const { pathname, query, push } = useRouter()

  async function gotToViewAndChangePageURL(view: string) {
    await push({ pathname, query: { ...query, aba: view } })
    setView(view)
  }

  const isExactPage = useMemo(() => {
    return view === pageKey
  }, [view, pageKey])

  return (
    <>
      <Trigger
        my={2}
        color={isExactPage ? 'primary' : 'dark'}
        _hover={{ bg: 'lighterPrimary' }}
        onClick={() => gotToViewAndChangePageURL(pageKey)}
      >
        <Flex h="40px" align="center" p={2} gap={2}>
          <ListIcon as={Icon} fontSize={24} ml={0} />
          <Text fontSize={14} transition="font-size 0.2s 0.2s">
            {name}
          </Text>
        </Flex>
      </Trigger>

      {Array.isArray(subItems) && subItems.length > 0 && (
        <Flex direction="column" pl={8}>
          {subItems.map((subItem) => (
            <Trigger
              key={subItem.pageKey}
              color={view === subItem.pageKey ? 'primary' : 'dark'}
              _hover={{ bg: 'lighterPrimary' }}
              onClick={() => gotToViewAndChangePageURL(subItem.pageKey)}
            >
              <Flex h="36px" align="center" p={2} gap={2}>
                <ListIcon as={subItem.Icon} fontSize={20} ml={0} />
                <Text fontSize={13} transition="font-size 0.2s 0.2s">
                  {subItem.name}
                </Text>
              </Flex>
            </Trigger>
          ))}
        </Flex>
      )}
    </>
  )
}

export default memo(SidebarWithViewsItem)
